import { PropertyChange } from "../PropertyChange";
import { Property } from "../RadObject";
import { Expression, ExpressionPropertyValues, IExpression } from "./Expression";
import { NAMESPACE } from "./_Namespace";

export type NotExpressionPropertyValues =
    ExpressionPropertyValues
    & {
        expression: Expression | string;
    };

export type NotExpressionProperties = {
    [name in keyof NotExpressionPropertyValues]: Property<NotExpressionPropertyValues[name]>
};

export interface INotExpression extends IExpression, NotExpressionProperties
{
}

export class NotExpression extends Expression<NotExpressionPropertyValues> implements INotExpression
{
    public static override classNamespace = NAMESPACE + "NotExpression";
    public static override className = "NotExpression";

    // #region Properties

    public expression!: Property<Expression | string>;

    // #endregion

    // #region Protected Methods

    protected _expressionChanged(change: PropertyChange<Expression | string>)
    {
        /* Intentionally empty */
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: NotExpressionPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.expression = new Property<Expression | string>(this, "System.Object, System.Private.CoreLib", propertyValues.expression, this._expressionChanged);
    }

    // #endregion
}